import { Tool } from './tool.js';
import * as glMatrix from '../../../../node_modules/gl-matrix';
import { BrushStroke } from '../../scene/stroke/brush.js';
export class DensityTool extends Tool {
    _size: number;
    _hardness: number;
    _exposure: number;
    plus: boolean;
    color: glMatrix.vec4;
    edit: boolean;
    stroke: BrushStroke;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'density', 'Densité');
        var self = this;
        try {
            self._size = JSON.parse(window.localStorage.getItem('PSDensityTool_size') || '');
            if (isNaN(self._size) || self.size === null) {
                self._size = 200;
            }
        } catch (e) {
            self._size = 200;
        }
        try {
            self._hardness = JSON.parse(window.localStorage.getItem('PSDensityTool_hardness') || '');
            if (isNaN(self._hardness) || self._hardness === null) {
                self._hardness = 0.0;
            }
        } catch (e) {
            self._hardness = 0.0;
        }
        try {
            self._exposure = JSON.parse(window.localStorage.getItem('PSDensityTool_exposure') || '');
            if (isNaN(self._exposure) || self._exposure === null) {
                self._exposure = 0.2;
            }
        } catch (e) {
            self._exposure = 0.2;
        }
        self.plus = false;
        self.color = glMatrix.vec4.create();
        self.edit = false;
        self.stroke = new BrushStroke(gl, width, height);
    }

    get size() {
        return this._size;
    }

    set size(value) {
        try {
            window.localStorage.setItem('PSDensityTool_size', value.toString());
        } catch (e) {
        }
        this._size = value;
    }

    get hardness() {
        return this._hardness;
    }

    set hardness(value) {
        try {
            window.localStorage.setItem('PSDensityTool_hardness', value.toString());
        } catch (e) {
        }
        this._hardness = value;
    }

    get exposure() {
        return this._exposure;
    }

    set exposure(value) {
        try {
            window.localStorage.setItem('PSDensityTool_exposure', value.toString());
        } catch (e) {
        }
        this._exposure = value;
    }

    destroy() {
        super.destroy();
        this.stroke.destroy();
    }

    static copy(value) {
        var result = new DensityTool(value._gl, value._width, value._height);
        result.size = value.size;
        result.hardness = value.hardness;
        result.exposure = value.exposure;
        result.plus = value.plus;
        result.color = value.color;
        result.edit = value.edit;
        return result;
    }

    addPoint(point) {
        var self = this;
        self.stroke.addPoint(point, self.size / self._width);
        self._touch = true;
    }
}
